import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {FormGroup, FormControl, Validators, Validator} from '@angular/forms';
import { ToastrService } from "ngx-toastr";

import { AuthenticationService } from '../../../core/services/authentication.service';
import { UserService } from '../../../core/services/user.service';
import { LanguageService } from '../../../core/services/language.service';
import { PasswordValidation } from '../../../utils/password-validation.util';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {
    user;
    updatingUser = {};
    formsGroup;

    constructor(private authService: AuthenticationService,
                private userService: UserService,
                private languageService: LanguageService,
                private toastr: ToastrService) {}

    ngOnInit() {
        this.user = this.userService.getUserInfo();
        this.initForm();
    }

    initForm() {
        this.formsGroup = new FormGroup({
            firstName: new FormControl('', [
                Validators.minLength(2),
                Validators.maxLength(244),
                Validators.required
            ]),
            lastName: new FormControl('', [
                Validators.minLength(2),
                Validators.maxLength(244),
                Validators.required
            ]),
            password: new FormControl('', [
                Validators.minLength(6),
                Validators.maxLength(244),
                Validators.required
            ]),
            passwordConfirmation: new FormControl('', [
                Validators.minLength(6),
                Validators.maxLength(244),
                Validators.required
            ])
        },
        {
            validators: PasswordValidation.MatchPassword
        })
    }

    saveFormBtn() {

        if (!this.formsGroup.dirty) {
            this.toastr.info(this.languageService.translate('MESSAGES.USER_UPDATE_INFO'), 'Info');
            return;
        } else if (this.checkFormValidity()) {
            this.toastr.error(this.languageService.translate('MESSAGES.FORM_VALIDITY'), 'Error');
            return;
        }

        delete this.updatingUser['passwordConfirmation'];

        this.userService.updateUserInfo(this.updatingUser)
            .then(() => {
                this.resetDirtyControls();
                this.updatingUser = {};
            })
    }

    checkFormValidity() {
        let checkErrors = true;

        for (let key in this.formsGroup.controls) {
            if (this.hasError(this.formsGroup.controls[key])) {
                checkErrors = true;
            } else if (key === 'passwordConfirmation' && !this.isDirty(this.formsGroup.controls[key])) {
                if (this.isDirty(this.formsGroup.controls.password)) {
                    checkErrors = true;
                }
            } else if (this.isDirty(this.formsGroup.controls[key])) {
                this.updatingUser[key] = this.formsGroup.controls[key].value;
                checkErrors = false;
            }
        }

        return checkErrors;
    }

    resetDirtyControls() {
        for (let key in this.formsGroup.controls) {
            if (this.isDirty(this.formsGroup.controls[key])) {
                this.formsGroup.controls[key].reset();
            }
        }
    }

    hasError(model) {
        return model.invalid && model.dirty;
    }

    isDirty(model) {
        return model.dirty;
    }

    logOut() {
        this.authService.logOut();
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/user-profile/profile/profile.component.ts